export default {
  sm: `
  오늘을 지키는
  데이터센터 각
  `,
};  